import {FC} from 'react'
import {Verified} from 'shared/ui/icons'
import {Tooltip} from 'shared/ui/tooltip'
import styles from './styles.module.scss'

export const TooltipConfirmed: FC<{iconWidth?: number; className?: string}> = ({
  iconWidth = 16,
  className
}) => {
  return (
    <Tooltip
      className={className || ''}
      title={
        <>
          <div className={styles.tooltipHeader}>Confirmed Account</div>
          <div className={styles.tooltipText}>
            This user has <br /> confirmed their account
          </div>
        </>
      }
    >
      <div
        className={styles.icon}
        style={{width: iconWidth, height: iconWidth}}
      >
        <Verified />
      </div>
    </Tooltip>
  )
}
